// import logo from './logo.svg';
import Styles from './HomePage.module.css'

import Images from 'Theme/Images'

function HomePage() {
  return (
    <div className={Styles.App}>
      <header className={Styles.AppHeader}>
        <img src={Images.logo} className={Styles.AppLogo} alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className={Styles.AppLink}
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  )
}

export default HomePage
